var React = require('react');

function Qrcode (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Qr_Code","data-name":"Qr Code","transform":"translate(-96 -762)"},[React.createElement("rect",{"id":"nền_24x24","data-name":"nền 24x24","width":"24","height":"24","transform":"translate(96 762)","fill":"#fff","key":0}),React.createElement("path",{"id":"qr_code-2","data-name":"qr code","d":"M0,10.821H8.571V2.25H0ZM2.857,5.107H5.714V7.964H2.857ZM11.429,2.25v8.571H20V2.25Zm5.714,5.714H14.286V5.107h2.857ZM0,22.25H8.571V13.679H0Zm2.857-5.714H5.714v2.857H2.857Zm15.714-2.857H20v5.714H15.714V17.964H14.286V22.25H11.429V13.679h4.286v1.429h2.857Zm0,7.143H20V22.25H18.571Zm-2.857,0h1.429V22.25H15.714Z","transform":"translate(98 761.75)","fill":"none","stroke":"#686868","strokeWidth":"1","key":1})]));
}

Qrcode.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Qrcode;

Qrcode.default = Qrcode;
